module.exports = __webpack_public_path__ + "static/img/baoming2.f55b812.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/en/baoming2.png
// module id = eeq9
// module chunks = 0